import React from 'react';
import Image from "next/image";
import {isAnimatedPoster} from "@/src/entities/competition/lib/isAnimatedPoster";

interface Props {
    logo?: string | null;
    logoVideo?: string | null;
    alt: string;
    className: string;
}

/**
 * Афиша соревнования: если организатор загрузил видео — проигрывает его
 * (без звука, по кругу), картинка при этом служит заставкой и запасным вариантом.
 */
function CompetitionPoster({logo, logoVideo, alt, className}: Props) {
    if (logoVideo) {
        return (
            <video
                className={className}
                poster={logo ?? undefined}
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                aria-label={alt}
            >
                <source src={logoVideo}/>
            </video>
        );
    }

    if (!logo) return null;

    return (
        <Image
            src={logo}
            alt={alt}
            className={className}
            width={1000}
            height={1000}
            unoptimized={isAnimatedPoster(logo)}
        />
    );
}

export default CompetitionPoster;
